import {
    OKTA_AUTHENTICATED,
    OKTA_FETCH_USER,
    OKTA_IS_FETCHING,
    OKTA_GROUPS
} from '../actions/actionTypes'
const initialState = {
    authenticated: null,
    user: null,
    isFetching: false,
    apps: null,
    groups: [],
    editGroups: ['sg-user-custom-contributor-admin'],
    confidentialGroups: ['sg-user-custom-contributor-SMT'],
    is_user_editor: false,
    is_user_confidential: false
}

const okta = (state = initialState, action) => {
    switch (action.type) {
        case OKTA_AUTHENTICATED:
            return {
                ...state,
                authenticated: action.value
            }
        case OKTA_FETCH_USER:
            return {
                ...state,
                user: action.user,
                isFetching: false
            }
        case OKTA_IS_FETCHING:
            return {
                ...state,
                isFetching: true
            }
        case OKTA_GROUPS:
            return {
                ...state,
                groups: action.groups || [],
                is_user_editor: (action.groups || []).some(r => (state.editGroups || []).indexOf(r) > -1),
                is_user_confidential: (action.groups || []).some(r => (state.confidentialGroups || []).indexOf(r) > -1)
            }
        default:
            return state
    }
}

export default okta